// TODO: Change this
// We should be caching setUnit
export const IsExerciseSetUnitSeconds = (exerciseId) => {
    return (
        exerciseId === 151 // Lower Leg Distraction
        || exerciseId === 161 // Thread the Needle
        || exerciseId === 331 // Single Leg Seated Isometric Bent Knee Hold
        || exerciseId === 333 // Single Leg Seated Calf Isometric
        || exerciseId === 334 // Seated Isometric Knee Extensions
        || exerciseId === 386 // Front Side Flutter
        || exerciseId === 387 // Back Side Flutter
    )
}